import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

const AppContext = createContext(null);

export function AppProvider({ children }) {
    const { user, loading: authLoading } = useAuth();
    const [hotel, setHotel] = useState(null);
    const [view, setView] = useState("staff"); // staff | guest
    const [now, setNow] = useState(new Date());
    const [system, setSystem] = useState(null);

    useEffect(() => {
        const t = setInterval(() => setNow(new Date()), 30_000);
        return () => clearInterval(t);
    }, []);

    useEffect(() => {
        if (authLoading) return;
        if (!user) {
            setHotel(null);
            setSystem(null);
            return;
        }

        let active = true;
        setHotel(null);
        setSystem(null);

        api.get("/admin/hotel")
            .then((r) => {
                if (active) setHotel(r.data);
            })
            .catch(() => {});
        const refresh = () => {
            api.get("/system/status")
                .then((r) => {
                    if (active) setSystem(r.data);
                })
                .catch(() => {
                    if (active) setSystem({ mongo: { ok: false }, llm: { healthy: false } });
                });
        };
        refresh();
        const t2 = setInterval(refresh, 60_000);
        return () => {
            active = false;
            clearInterval(t2);
        };
    }, [user, authLoading]);

    return (
        <AppContext.Provider value={{ hotel, view, setView, now, system }}>
            {children}
        </AppContext.Provider>
    );
}

export function useApp() {
    return useContext(AppContext);
}
